import {
  IconBrandJavascript,
  IconBrandTypescript,
  IconBrain,
  IconBrandReact,
  IconBrandVue,
  IconBrandAngular,
  IconBrandSvelte,
  IconBrandSolidjs,
  IconCode,
} from "@tabler/icons-react";

export const technologies = [
  { name: "javascript", formattedName: "JavaScript", icon: IconBrandJavascript, color: "yellow-400" },
  { name: "typescript", formattedName: "TypeScript", icon: IconBrandTypescript, color: "blue-500" },
  { name: "ai", formattedName: "AI", icon: IconBrain, color: "green-500" },
  { name: "react", formattedName: "React", icon: IconBrandReact, color: "cyan-500" },
  { name: "vue", formattedName: "Vue", icon: IconBrandVue, color: "emerald-500" },
  { name: "angular", formattedName: "Angular", icon: IconBrandAngular, color: "red-500" },
  { name: "svelte", formattedName: "Svelte", icon: IconBrandSvelte, color: "orange-500" },
  { name: "solidjs", formattedName: "SolidJS", icon: IconBrandSolidjs, color: "blue-600" },
  { name: "qwik", formattedName: "Qwik", icon: IconCode, color: "purple-500" },
];
